export default "__VITE_ASSET__3242b947__"